import { z } from 'zod';
import { AuditedFields, CursorPageQuery, Email, IsoDateTime, Locale, PhoneE164, Uuid, Version, } from './common.js';
export const UserStatus = z.enum(['INVITED', 'ACTIVE', 'DISABLED']);
export const UserRoleAssignment = z.object({
    roleId: Uuid,
    propertyId: Uuid.nullable().default(null),
});
export const User = z
    .object({
    id: Uuid,
    email: Email,
    fullName: z.string(),
    phone: PhoneE164.nullable(),
    locale: Locale,
    status: UserStatus,
    mfaEnabled: z.boolean(),
    lastLoginAt: IsoDateTime.nullable(),
    roles: z.array(z.object({
        roleId: Uuid,
        roleCode: z.string(),
        roleName: z.string(),
        propertyId: Uuid.nullable(),
    })),
    version: Version,
})
    .merge(AuditedFields);
export const InviteUserRequest = z.object({
    email: Email,
    fullName: z.string().min(2).max(120),
    phone: PhoneE164.optional(),
    locale: Locale.default('fr'),
    roles: z.array(UserRoleAssignment).min(1, 'Au moins un rôle'),
});
/**
 * Lien d'activation ou de réinitialisation remis **à l'écran** à l'administrateur
 * (D-055) : la messagerie peut être absente ou en panne, l'administrateur
 * transmet alors le lien lui-même (WhatsApp, en main propre). L'e-mail reste
 * envoyé quand la messagerie est configurée (`emailSent`).
 */
export const DeliveryLink = z.object({
    url: z.string().url(),
    expiresAt: IsoDateTime,
    purpose: z.enum(['INVITATION', 'PASSWORD_RESET']),
    emailSent: z.boolean(),
});
/** Réponse de `POST /users` : le compte créé et son lien d'activation. */
export const InviteUserResponse = User.extend({ activation: DeliveryLink });
export const UpdateUserRequest = z.object({
    fullName: z.string().min(2).max(120).optional(),
    phone: PhoneE164.nullable().optional(),
    locale: Locale.optional(),
    roles: z.array(UserRoleAssignment).min(1).optional(),
    version: Version,
});
export const ListUsersQuery = CursorPageQuery.extend({
    q: z.string().max(100).optional(),
    status: UserStatus.optional(),
    roleCode: z.string().optional(),
});
//# sourceMappingURL=users.js.map